import { render, staticRenderFns } from "./ShoppingHistory.vue?vue&type=template&id=0ab7c890"
import script from "./ShoppingHistory.vue?vue&type=script&setup=true&lang=js"
export * from "./ShoppingHistory.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports